<template>
  <div>
    <employee-form ref="employeeForm" @employee-submitted="updateList += 1" @removed="updateList += 1" />

    <m-manage-filters
      :active="manageFiltersModal"
      :costructor="true"
      :enabled-fields="enabledFields"
      module="employees"
      :query="query"
      :field-values="fieldValues"
      @close="manageFiltersModal = null"
      @openConstructorModal="openConstructorModal"
      @setFilters="setFilters"
    />

    <m-filter-constructor
      :active="constructorModal"
      module="employees"
      :current-filters="currentFilters"
      @close="closeConstructorModal"
      @save="constructorSave"
      @applyFiltersFields="applyFiltersFields"
    />

    <div class="layout employees">
      <c-loader
        v-if="isLoadingExcelFile"
        label="Загружаем список сотрудников в Excel-файл"
        :active="isLoadingExcelFile"
        height="fixed"
      />
      
      <div class="layout-header">
        <div class="layout-title">Сотрудники</div>
        <div class="layout-header-actions">
          <!-- <div class="layout-header-action">
            <c-button
              size="small"
              :icon="{
                icon: 'bookmark',
                activeColor: 'white',
              }"
              :tooltip="{
                text: 'Добавить в закладки',
                activeText: 'Убрать из закладок',
              }"
              active-color="blue"
              :active="bookmark"
              @click="bookmark = !bookmark"
            />
          </div> -->

          <div class="layout-header-action">
            <div class="layout-header-action-dropdown">
              <div
                class="c-button__dropdown__container__overlay"
                :class="{
                  'c-button__dropdown__container__overlay__active': isActiveDropdown,
                }"
                @click="isActiveDropdown = false"
              ></div>

              <div class="c-button c-button_with-icon c-button_responsive">
                <div
                  class="c-button__wrapper"
                  :class="{ 'c-button__wrapper__active': isActiveDropdown }"
                  @click="isActiveDropdown = !isActiveDropdown"
                >
                  <div class="c-button__label__left">Действия</div>

                  <div class="c-button__icon__right">
                    <c-icon icon="arrow" />
                  </div>

                  <div
                    class="c-button__dropdown__container c-button__dropdown__container__left"
                    :class="{
                      'c-button__dropdown__container__active': isActiveDropdown,
                    }"
                  >
                    <div class="c-button__dropdown__container__list">
                      <google-form ref="googleForm" class="c-button__dropdown__container__list__item">
                        <c-icon icon="google" color="success" />
                        <div class="c-button__dropdown__container__list__item__label">Выгрузить в Google Таблицы</div>
                      </google-form>

                      <div
                        class="c-button__dropdown__container__list__item"
                        :class="{
                          disabled: !$refs.route || $refs.route._data.isLoadingTable,
                        }"
                        @click="exportEmployeeTableToExcel"
                      >
                        <c-icon icon="excel" color="success"></c-icon>
                        <div class="c-button__dropdown__container__list__item__label">Выгрузить в Excel</div>
                      </div>

                      <div
                        class="c-button__dropdown__container__list__item"
                        :class="{
                          disabled: !$refs.route || $refs.route._data.isLoadingTable,
                        }"
                        @click="manageFiltersModal = 'list'"
                      >
                        <c-icon icon="filter"></c-icon>
                        <div class="c-button__dropdown__container__list__item__label">Управление фильтрами</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="layout-header-action layout-header-action-new-employee" v-if="isAllowedToEditAllWorkers">
            <c-button-2
              size="small"
              label="Новый сотрудник"
              :icon="{
                icon: 'plus',
                color: 'blue',
              }"
              @click="goToCreateEmployee"
            />
          </div>

          <div class="layout-header-action layout-header-action-new-employee-mobile">
            <c-button-2
              size="small"
              responsive
              label="Новый сотрудник"
              :icon="{
                icon: 'plus',
                color: 'blue',
              }"
              @click="goToCreateEmployee"
            />
          </div>
        </div>
      </div>

      <template v-if="filtersInited">
        <div
          v-if="enabledFields && enabledFields.length > 0"
          class="employees__fields"
          :class="{ employees__fields_active: filtersVisible }"
        >
          <b-row align-v="center" cols="12">
            <b-col v-for="field in enabledFields" :key="field.name" sm="12" md="6" :lg="'' + field.cols">
              <div class="employees__fields-item">
                <c-input
                  v-if="field.type === 'text'"
                  v-model="field.value"
                  :label="field.label"
                  :clearable="field.clearable ? field.clearable : undefined"
                  :placeholder="field.placeholder ? field.placeholder : undefined"
                />
                <c-input
                  v-if="field.type === 'select' && !field.groups"
                  v-model="field.value"
                  :type="field.type"
                  :label="field.label"
                  :checkbox="field.checkbox"
                  :checkbox-value="field.checkboxValue"
                  :checkbox-type="'icon'"
                  :checkbox-tooltip="{
                    disabledText: 'Фильтр по всем значениям в справочнике, кроме выбранных',
                    activeText: 'Выключить фильтр по всем значениям в справочнике, кроме выбранных',
                    notActiveText: 'Включить фильтр по всем значениям в справочнике, кроме выбранных',
                  }"
                  :multiple="field.multiple ? field.multiple : undefined"
                  :searchable="field.searchable ? field.searchable : undefined"
                  :clearable="field.clearable ? field.clearable : undefined"
                  :placeholder="field.placeholder ? field.placeholder : undefined"
                  :items="field.values"
                  @checkboxChange="inputCheckboxChange"
                />
                <c-select
                  v-if="field.type === 'select' && field.groups"
                  v-model="field.value"
                  :type="field.type"
                  :label="field.label"
                  :reverse="field.checkboxValue"
                  :reverse-type="'icon'"
                  :reverse-tooltip="{
                    disabledText: 'Фильтр по всем значениям в справочнике, кроме выбранных',
                    activeText: 'Выключить фильтр по всем значениям в справочнике, кроме выбранных',
                    notActiveText: 'Включить фильтр по всем значениям в справочнике, кроме выбранных',
                  }"
                  :multiple="field.multiple ? field.multiple : undefined"
                  :searchable="field.searchable ? field.searchable : undefined"
                  :placeholder="field.placeholder ? field.placeholder : undefined"
                  :items="field.values"
                  :groups="field.groups"
                  @changeReverse="inputCheckboxChange"
                />
                <c-switcher
                  v-if="field.type === 'switcher'"
                  v-model="field.value"
                  class="employees__fields-item-switcher"
                  :label="field.label"
                />
                <c-range
                  v-if="field.type === 'range'"
                  v-model="field.value"
                  class="employees__fields-item-range"
                  :max="field.max"
                  :min="field.min"
                  :label="field.label"
                />
              </div>
            </b-col>
            <b-col col>
              <div class="employees__fields-actions">
                <div class="employees__fields-actions-item employees__fields-actions-item-hide-filters">
                  <c-button label="Свернуть" @click="hideFilters" />
                </div>
                <div class="employees__fields-actions-item">
                  <c-button
                    :disabled="!$refs.route || $refs.route._data.isLoadingTable"
                    label="Сбросить"
                    @click="resetFilters"
                  />
                </div>
                <div class="employees__fields-actions-item">
                  <c-button
                    :disabled="!$refs.route || $refs.route._data.isLoadingTable"
                    label="Применить"
                    color="primary"
                    @click="applyFilters"
                  />
                </div>
                <div class="employees__fields-actions-item employees__fields-actions-item-hide-filters-mobile">
                  <c-button label="Свернуть фильтры" color="white" @click="hideFilters" />
                </div>
              </div>
            </b-col>
          </b-row>
        </div>

        <div
          v-if="enabledFields && enabledFields.length > 0"
          class="employees__fields-show"
          :class="{ 'employees__fields-show_active': !filtersVisible }"
        >
          <c-button label="Показать фильтры" @click="showFilters" />
        </div>
      </template>

      <template v-else>
        <c-loader :active="true" label="Инициализация фильтров" :height="300" />
      </template>

      <div class="employees__tabs">
        <c-tabs :items="tabs.items" with-routing />
      </div>

      <div class="employees__content">
        <router-view
          ref="route"
          :key="updateList"
          :enabled-fields="enabledFields"
          :enabled-filters="enabledFilters"
          @globalFiltersActive="setFieldsValues"
          @setTabsQuery="setTabsQuery"
          @update="updateGoogleSpreadsheetForm"
          @edit-worker="onEmployeeEdit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import VueCookies from "vue-cookies";
import Vue from "vue";

import Button from "@/components/controls2/Button";
import button from "@/components/controls/button";
import Input from "@/components/controls2/Input";
import Switcher from "@/components/controls/switcher";
import Select from "@/components/controls2/Select";
import Range from "@/components/controls/range";
import Icon from "@/components/icon";

import Tabs from "@/components/tabs";

import ManageFilters from "@/components/modals/manage-filters";
import FilterConstructor from "@/components/modals/filter-constructor";
import loader from "@/components/loader";

import EmployeeForm from "@/pages/employees/employee-form";
import GoogleForm from "@/pages/employees/google-form";
import { getFiltersFromQuery, transformFiltersToQuery } from "./employees/utils/formatFilters";

Vue.use(VueCookies);

const FILTERS_STORAGE_ITEM = "hrm-employee-filters";

export default {
  name: "employees",

  components: {
    "c-button": Button,
    "c-button-2": button,
    "c-input": Input,
    "c-select": Select,
    "c-switcher": Switcher,
    "c-range": Range,
    "c-loader": loader,
    "c-icon": Icon,

    "c-tabs": Tabs,

    "m-manage-filters": ManageFilters,
    "m-filter-constructor": FilterConstructor,
    GoogleForm,
    EmployeeForm,
  },

  data() {
    return {
      isActiveDropdown: false,
      bookmark: false,
      manageFiltersModal: null,
      constructorModal: false,
      currentUserId: 1,
      updateList: 0,

      filtersInited: false,
      fieldValues: {},

      enabledFields: [],

      enabledFilters: [],

      filtersVisible: this.$cookies.get("filtersVisible") !== "false",

      query: {},

      tableSettingsModal: false,

      currentFilters: [],

      isLoadingExcelFile: false,
    };
  },

  computed: {
    ...mapGetters({
      getRecords: "employees/getRecords",
      isAllowedForMapTab: "employees/isAllowedForMapTab",
      isAllowedToEditAllWorkers: "employeeForm/isAllowedToEditAllWorkers",
      getUserPermissions: "getUserPermissions",
    }),
    tabs() {
      const items = [
        {
          label: "Список сотрудников",
          value: "employees-list",
          query: {
            sortBy: "created",
            sortType: "desc",
          },
        },
        { label: "Отчеты", value: "employees-reports", query: {} },
        // { label: 'Отчеты по периоду', value: 'employees-period-reports' },
      ];

      if (this.isAllowedForMapTab) {
        items.push({
          label: "На карте",
          value: "employees-map",
        });
      }

      return { items };
    },
  },

  watch: {
    filtersVisible() {
      if (this.$refs.route.$refs.table !== undefined) {
        this.$refs.route.$refs.table.updatePositionTop();
      }
    },

    enabledFields: {
      deep: true,
      handler(value) {
        value.forEach((filter) => {
          if (filter.type === "select" && filter.value && filter.value.length === 0) {
            const c = this.enabledFields.findIndex((field) => field.name === filter.name);
            if (c !== -1) {
              if (this.enabledFields[c].checkboxValue !== undefined) this.enabledFields[c].checkboxValue = false;
            }
          }
        });
      },
    },
  },

  created() {
    const { query } = this.$route;

    if (Object.keys(query).length) return;

    const defaultFilters = this.getDefaultFilters();
    const defaultQuery = transformFiltersToQuery(defaultFilters);

    if (JSON.stringify(query) !== JSON.stringify(defaultQuery)) {
      this.$router.replace({ query: defaultQuery });
    }
  },

  mounted() {
    this.initFieldValues();
    window.addEventListener("keyup", (event) => {
      if (event.keyCode === 13) {
        this.applyFilters();
      }
    });
  },

  methods: {
    onEmployeeEdit(workerId) {
      const userPermissions = this.getUserPermissions;
      //console.log(2000, userPermissions)
      this.$refs.employeeForm.open(workerId, !userPermissions.includes("hideWorkerStatus"));
    },
    goToCreateEmployee() {
      const userPermissions = this.getUserPermissions;
      this.$refs.employeeForm.open(null, !userPermissions.includes("hideWorkerStatus"));
    },

    getGoogleSpreadsheetParams() {
      const { sortBy } = this.$refs.route.tableData.sortedColumn;
      const { sortType } = this.$refs.route.tableData.sortedColumn;
      const { activeFilteredColumns } = this.$refs.route.tableData;
      const { globalFilters } = this.$refs.route.tableData;

      return {
        sortBy,
        sortType,
        activeFilteredColumns,
        globalFilters,
      };
    },

    updateGoogleSpreadsheetForm() {
      const params = this.getGoogleSpreadsheetParams();
      this.$refs.googleForm.update(params);
    },

    exportEmployeeTableToExcel() {
      const { page } = this.$refs.route;
      const { sortBy } = this.$refs.route.tableData.sortedColumn;
      const { sortType } = this.$refs.route.tableData.sortedColumn;
      const { activeFilteredColumns } = this.$refs.route.tableData;
      const { globalFilters } = this.$refs.route.tableData;

      if (this.$refs.route || !this.$refs.route._data.isLoadingTable) {
        this.$refs.route.isDisabledScrollDataLoading = true;
        this.isLoadingExcelFile = true;
        this.$store
          .dispatch("employees/getRecords", [
            page,
            sortBy,
            sortType,
            {
              localFilters: [...activeFilteredColumns],
              globalFilters: [...globalFilters],
            },
            1,
          ])
          .then((res) => {
            const url = new URL(res.upload_url);
            const urlToExcelFile = window.location.origin + url.pathname;
            this.$refs.route.isDisabledScrollDataLoading = false;
            // eslint-disable-next-line no-restricted-globals
            location.href = urlToExcelFile;
            this.isLoadingExcelFile = false;
          })
          .catch(() => {
            console.error("При попытке скачать файл произошла ошибка");
            this.isLoadingExcelFile = false;
          });
      }
    },

    applyFilters() {
      const enabledFilters = [];
      this.enabledFields.forEach((field) => {
        switch (field.type) {
          case "select": {
            let filterValue = [];
            if (Array.isArray(field.value)) {
              filterValue = field.value.map((i) => ({ id: i.value, label: i.label }));
            }
            if (field.value && field.value.value) {
              filterValue = [{ id: field.value.value }];
            }
            enabledFilters.push({
              id: `${field.name}_global`,
              searchType: field.checkboxValue !== undefined && field.checkboxValue ? "2" : "1",
              type: "list",
              value: filterValue,
            });
            break;
          }
          case "text":
            enabledFilters.push({
              id: `${field.name}_global`,
              searchType: "1",
              type: "string",
              value: field.value,
            });
            break;
          case "range":
            enabledFilters.push({
              id: `${field.name}_global`,
              searchType: "4",
              type: "number",
              value: {
                start: field.value[0],
                end: field.value[1],
              },
            });
            break;
          case "switcher":
            enabledFilters.push({
              id: `${field.name}_global`,
              type: "boolean",
              value: field.value ? "1" : "0",
            });
            break;
          default:
            break;
        }
      });
      this.enabledFilters = [...enabledFilters];

      this.updateDefaultFilters(this.enabledFilters);
    },

    showFilters() {
      this.filtersVisible = true;
      Vue.$cookies.set("filtersVisible", this.filtersVisible);
      this.$nextTick(() => {
        if (this.$refs.route.$refs.table !== undefined) this.$refs.route.$refs.table.updatePositionTop();
      });
    },

    hideFilters() {
      this.filtersVisible = false;
      Vue.$cookies.set("filtersVisible", this.filtersVisible);
      this.$nextTick(() => {
        if (this.$refs.route.$refs.table !== undefined) this.$refs.route.$refs.table.updatePositionTop();
      });
    },

    setFilters(filters) {
      this.currentFilters = filters;
    },

    resetFilters() {
      this.enabledFilters = this.enabledFields.map((item) => {
        if (item.type === "range") {
          item.value = [0, 0];
        } else if (item.name === "questCompletion") {
          item.value = "";
        } else if (item.name === "workerType") {
          item.value = { id: 0, label: "Все" };
        } else if (Array.isArray(item.value)) {
          item.value = [];
          item.checkboxValue = false;
        } else if (typeof item.value === "boolean") {
          item.value = false;
        } else if (item.type === "text") {
          item.value = "";
        }
        return item;
      });

      this.applyFilters();
    },

    openConstructorModal() {
      this.constructorModal = true;
    },

    closeConstructorModal() {
      this.constructorModal = false;
    },

    changeReverse(value, fieldName) {
      this.fieldValues[fieldName].reverse = value;
    },

    constructorSave(fields) {
      this.enabledFields = fields;

      // this.manageFiltersModal = 'save';
    },

    applyFiltersFields(filters) {
      this.enabledFields = filters;
    },

    initFieldValues() {
      const fieldValues = {};

      // не вкурсе откуда this.getFields но оно так было так что оставим _)
      if (this.getFields) {
        Object.keys(this.getFields).forEach((key) => {
          const field = this.getFields[key];

          fieldValues[field.name] = {
            value: field.value ? field.value : null,
            reverse: false,
            field,
          };
        });
      }

      this.fieldValues = fieldValues;

      console.log('Поля', this.fieldValues)
    },

    getDefaultFilters() {
      let filters = [];
      const data = localStorage.getItem(FILTERS_STORAGE_ITEM);

      if (data) {
        try {
          filters = JSON.parse(data);
        } catch (e) {}
      }

      return filters;
    },

    updateDefaultFilters(value) {
      localStorage.setItem(FILTERS_STORAGE_ITEM, JSON.stringify(value));
    },

    setFieldsValues() {
      const globalFiltersActive = getFiltersFromQuery(
        this.$store.getters["employees/getAllFilters"],
        this.$route.query,
      );

      this.updateDefaultFilters(globalFiltersActive);

      const enabledFields = [...this.enabledFields];

      globalFiltersActive.forEach((filter) => {
        const filterId = filter.id.split("_")[0];
        const c = enabledFields.findIndex((i) => i.name === filterId);
        if (c !== -1) {
          switch (filter.type) {
            case "list": {
              const mapValues = [];
              filter.value.forEach((i) => {
                const indexVal = enabledFields[c].values.findIndex((item) => `${item.value}` === `${i.id}`);
                if (indexVal !== -1) mapValues.push(enabledFields[c].values[indexVal]);
              });
              if (filterId === "questCompletion" || filterId === "workerType") {
                const [firstValue] = mapValues;
                enabledFields[c].value = firstValue;
              } else {
                enabledFields[c].value = [...mapValues];
              }
              enabledFields[c].checkboxValue = filter.searchType !== "1";
              break;
            }
            case "string":
              enabledFields[c].value = filter.value;
              break;
            case "boolean":
              enabledFields[c].value = filter.value === "1";
              break;
            case "number":
              if (filter.searchType === "4") {
                const start = Number(filter.value.start);
                const end = Number(filter.value.end);
                enabledFields[c].value = [start, end];
              } else {
                console.error("Неизвестный тип фильтра, значение не будет подставлено в поле");
              }
              break;
            default:
              console.error("Неизвестный тип фильтра, значение не будет подставлено в поле");
          }
        }
      });
      this.enabledFields = [...enabledFields];

      this.filtersInited = true;

      this.tabs.items.forEach((routeItem) => {
        routeItem.query = { sortBy: "created", sortType: "desc" };
        Object.entries(this.$route.query).forEach(([filterId, filterValue]) => {
          const isGlobalFilter = filterId.split("_").includes("global");
          if (isGlobalFilter) {
            routeItem.query = { ...routeItem.query, [filterId]: filterValue };
          }
        });
      });
    },

    getSelectItems(field) {
      if (!field.reference) {
        return field.items;
      }
      if (!field.relatedReference) {
        return this[field.reference].map((item) => ({
          value: item.id,
          label: item.label,
        }));
      }
      if (field.name === "specialty") {
        return this[field.reference].map((item) => ({
          value: item.id,
          label: item.label,
          group: item.positionId,
        }));
      }
      return undefined;
    },

    getSelectGroups(field) {
      if (field.relatedReference) {
        return this[field.relatedReference].map((item) => ({
          name: item.id,
          label: item.label,
        }));
      }
      return undefined;
    },

    inputCheckboxChange(value, label) {
      const c = this.enabledFields.findIndex((item) => item.label === label);
      this.enabledFields[c].checkboxValue = value;
    },

    setTabsQuery(value) {
      if (value !== undefined) {
        this.tabs.items.forEach((routeItem) => {
          routeItem.query = { sortBy: "created", sortType: "desc", ...value };
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.layout-header-action-new-employee {
  @media screen and (max-width: 700px) {
    display: none;
  }
}

.layout-header-action-new-employee-mobile {
  display: none;

  @media screen and (max-width: 700px) {
    display: block;
  }
}

.employees {
  padding: 33px 30px 30px 30px;
  position: relative;

  @media screen and (max-width: 1000px) {
    padding: 33px 30px 30px 30px;
  }

  @media screen and (max-width: 700px) {
    padding: 20px;
  }

  &__fields {
    max-height: 0;
    overflow: hidden;
    transition: 0.3s;

    &_active {
      max-height: none;
      overflow: visible;
    }

    &-item {
      margin-bottom: 30px;

      &-switcher {
        margin-top: 20px;

        @media screen and (max-width: 768px) {
          margin-top: 0;
        }
      }

      &-range {
        @media screen and (max-width: 767px) {
          ::v-deep & .c-range-wrapper {
            flex-direction: column;
          }

          ::v-deep & .c-range-wrapper .c-range-control {
            width: 100%;
          }

          ::v-deep & .c-range-wrapper .c-range-values {
            margin-left: 0;
            margin-top: 22px;
          }

          ::v-deep & .c-range-wrapper .c-range-values .c-range-input {
            width: 50%;
          }
        }
      }
    }

    &-actions {
      width: 100%;
      display: flex;
      justify-content: flex-end;

      &-item {
        margin-left: 10px;

        @media screen and (max-width: 700px) {
          width: 50%;
        }

        @media screen and (max-width: 700px) {
          &:nth-child(2) .c-button,
          &:nth-child(3) .c-button {
            width: 95%;
          }
          &:nth-child(3) {
            display: flex;
            justify-content: flex-end;
          }
        }

        @media screen and (max-width: 700px) {
          &-hide-filters {
            display: none;
          }
        }

        &-hide-filters-mobile {
          display: none;
        }

        @media screen and (max-width: 700px) {
          &:nth-child(3) {
            margin: 0 auto;
          }

          &-hide-filters-mobile {
            margin: 0 auto !important;
            display: flex;
            width: 100%;
            justify-content: center;
            margin-bottom: 10px !important;

            & .c-button {
              height: 30px;
              font-size: 12px;
              font-weight: bold;
              width: 100%;
              //color: #0066FF;

              ::v-deep .c-button-label {
                //pointer-events: none;
              }
            }
          }
        }
      }

      @media screen and (max-width: 700px) {
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: -20px;

        &-item {
          margin-left: 0;
          margin-bottom: 20px;
        }
      }
    }

    &-show {
      opacity: 0;
      display: none !important;
      transition: 0.2s;
      pointer-events: none;

      &_active {
        pointer-events: auto;
        opacity: 1;
        display: block !important;

        @media screen and (max-width: 700px) {
          & > button {
            margin-bottom: 20px;
          }
        }
      }

      @media screen and (max-width: 700px) {
        display: flex !important;
        justify-content: center;
        width: 100%;
      }

      @media screen and (max-width: 700px) {
        & .c-button {
          width: 100%;
          height: 30px;
          font-size: 12px;
          font-weight: bold;
        }
      }
    }
  }

  &__tabs {
    margin-top: 18px;

    @media screen and (max-width: 700px) {
      margin-top: 0;
    }
  }

  &__content {
    margin-top: 22px;
  }
}
</style>

<style lang="scss">
@import "~@/assets/styles/vars";

.layout-header-action-dropdown {
  .c-button {
    &__wrapper {
      position: relative;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      transition: 0.2s;
    }

    &_responsive {
      @media screen and (max-width: 992px) {
        .c-button__wrapper {
          width: 30px;
          padding: 0;
        }

        .c-button__label {
          display: none;

          &__left {
            display: none;
          }
        }

        .c-button__icon {
          margin-left: -10px !important;
          display: inline-block;
        }

        .c-icon__wrapper {
          margin-left: -10px;
        }
      }
    }

    &_with-icon {
      .c-button {
        &__wrapper {
          height: 30px;
          border: 1px solid $color-button-border;
          box-sizing: border-box;
          padding: 0 15px;
          border-radius: 15px;

          &:hover {
            border-color: $color-button-border-hover;
          }

          &:active {
            border-color: $color-button-border-clicked;
          }

          &__active {
            border-color: $color-button-border-clicked;
          }
        }

        &__icon {
          margin-left: -5px;
          width: 20px;
          height: 20px;
        }

        &__icon__right {
          margin-right: -5px;
          width: 20px;
          height: 20px;
          & .c-icon_arrow {
            margin-left: -6px;
          }
        }

        &__label {
          margin-left: 8px;
          white-space: nowrap;

          font: {
            size: 12px;
            weight: 500;
          }
          &__left {
            margin-left: 5px;
            margin-right: 5px;

            font: {
              size: 12px;
              weight: 500;
            }
          }
        }
      }
    }

    &__dropdown__container {
      position: absolute;
      visibility: hidden;
      -webkit-transition: 0.2s;
      transition: 0.2s;
      opacity: 0;
      z-index: 300;
      padding: 10px;
      width: auto;
      background: #ffffff;
      box-shadow: 0px 4px 16px rgba(0, 15, 38, 0.25);
      border-radius: 6px;
      top: 34px;

      &__left {
        right: 0 !important;
      }

      &__center {
        left: 50% !important;
        transform: translate(-50%, 0);
      }

      &__right {
        left: 0 !important;
      }

      &__active {
        opacity: 1;
        visibility: visible;
      }

      &__overlay {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: $z-index-overlay;
        visibility: hidden;
        opacity: 0;
        transition: 0.2s;

        &__active {
          visibility: visible;
          opacity: 1;
        }
      }

      &__list {
        display: flex;
        flex-direction: column;

        &__item {
          display: flex;
          align-items: center;
          border-radius: 50px;
          padding: 0 15px;

          &:hover {
            background: #e1edff;
          }

          button[type="submit"] {
            border: 0;
            outline: 0;
            box-shadow: none;
            background-color: transparent;
            white-space: nowrap;
            font: 400 15px Fira Sans;
            display: flex;
            align-items: center;

            .c-icon {
              margin-right: 9px;
              svg {
                margin-top: 3px;
              }
            }
          }

          &__label {
            font: 400 15px Fira Sans;
            line-height: 190%;
            white-space: nowrap;
          }
        }

        &__item > .c-icon {
          margin: 0 9px 0 0 !important;
        }

        svg {
          transform: translate(-50%, -50%) !important;
        }
      }

      @include mobileAndTablet {
        .c-icon {
          margin-right: 0 !important;
        }
      }

      @include onlyMobile {
        transform: translateX(45px);
      }
    }
  }
}
</style>
